import React from 'react'
import './ValueInput.css';
import '../Theme.css';

function ValueInput({style, text, unit, placeholder, onValueChanged, disabled = false}) {

    const onTextChanged = (event) => {
        let text = event.target.value

        if (text === ".") text = "1";
        if (text === "0") text = "1";

        text = text.replace(/[^\d.]/g, ''); // Remove characters
        text = text.replace(/^0+/g, ''); // Remove leading zeroes
        text = text.replace(/[.](?=.*[.])/g, ""); // Remove multiple dots

        onValueChanged(text);
    }

    const className = "ValueInput " + style;

    return (
        <div className="ValueInputRoot">
            <input className={className}
                   disabled={disabled}
                   type="text"
                   value={text}
                   placeholder={placeholder}
                   onChange={onTextChanged}/>
            <p>{unit}</p>
        </div>
    )
}

export default ValueInput;
